<img src="{{photoUrl | async}}" alt="{{photoObj.filename}}" [ngStyle]="applyStyles()"/>

<div class="icon-row">
    <button mat-icon-button *ngIf="!readonly" >
        <mat-icon (click)="onEdit()">edit</mat-icon>
        <mat-icon (click)="onDelete()">delete</mat-icon>
        [Album: {{photoObj.album}}]
    </button>
</div>
